import Vue from 'vue';
import properties from "./PropertiesMap";

export const GlobalEudoxusBus = new Vue();
//for Production
let BASE_URL = '../../../distribution/distributioncontroller/';
// let BASE_URL = 'http://127.0.0.1:9080/distribution/distributioncontroller/';
// for Develop
// let BASE_URL = 'distribution/distributioncontroller/';

let DISTRIBUTION_POINT_ID;
let DISTRIBUTION_POINT_TYPE = false;

let requests = {

  logout() {
    $.ajax({
      type: "POST",
      url: BASE_URL + "logout",
      cache: false,
      timeout: 600000,
      success: function (result) {
        //console.log(result);
        location.reload();
      },
      error: function (error) {
        console.log(JSON.stringify(error));
        console.log("----------------------");
        //console.log(requests.getCookie("authCookieDistPoint"));
        location.reload();
      }
    });
  },

  login(username, password, callbackSuccess, callbackFail) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "login",
      data: {
        username: username,
        password: password
      },
      async: false,
      cache: false,
      timeout: 600000,
      success: function (result) {
        //console.log(result);
        if (result.result === 'true') {
          callbackSuccess();
          GlobalEudoxusBus.$emit('globalSetupEvent', true);
        } else
          callbackFail();
      },
      error: function (error) {
        console.log(error);
        callbackFail();
      }
    });
  },

  autoLogUser(callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "getLoggedOnUser",
      cache: false,
      timeout: 600000,
      success: function (result) {
        //console.log(result);
        requests.EudoxusGlobalVariables(result);
        GlobalEudoxusBus.$emit('globalSetupEvent', true);
        GlobalEudoxusBus.$emit('distributionPointDto', result);
        callbackSuccess(result);
      },
      error: function (error) {
        console.log(error);
        GlobalEudoxusBus.$emit('toggleLoginModal', true);
      }
    });
  },

  getLoggedOnUser(callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "getLoggedOnUser",
      cache: false,
      async: false,
      timeout: 600000,
      success: function (result) {
        //console.log(result);
        requests.EudoxusGlobalVariables(result);
        GlobalEudoxusBus.$emit('distributionPointDto', result);
        callbackSuccess(result);
      },
      error: function (error) {
        console.log(JSON.stringify(error));
        alert("Πραγματοποιήθηκε κάποιο σφάλμα. Παρακαλώ συνδεθείτε ξανά!");
        requests.reloadEudoxusPage("getLoggedOnUser");
      }
    });
  },

  getDistributionValidDates() {
    $.ajax({
      type: "POST",
      url: BASE_URL + "getDistributionValidDates",
      cache: false,
      timeout: 600000,
      success: function (result) {
        GlobalEudoxusBus.$emit('distributionValidDatesDto', result);
        GlobalEudoxusBus.$emit('reportsTabsLayoutSetup', requests.getDistributionType());
        GlobalEudoxusBus.$emit('publisherBooks', true);
      },
      error: function () {
        //alert("Πραγματοποιήθηκε κάποιο σφάλμα. Παρακαλώ συνδεθείτε ξανά!");
        requests.reloadEudoxusPage("getDistributionValidDates");
      }
    });
  },

  getBooksForDelivery(pin, receiverIdentification, callbackSuccess) {
    GlobalEudoxusBus.$emit('toggleLoading', true);
    $.ajax({
      type: "POST",
      url: BASE_URL + "getBooksForDelivery",
      data: {
        pin: pin,
        receiverIdentification: receiverIdentification
      },
      cache: false,
      timeout: 600000,
      success: function (result) {
        let object = [];
        let credits = [];
        credits.push({pin: pin, receiverIdentification: receiverIdentification});
        object.push({result: result, credits: credits});
        if (callbackSuccess != null)
          callbackSuccess(object);
        else
          GlobalEudoxusBus.$emit('bookListComponentRenderDto', object);
        GlobalEudoxusBus.$emit('toggleLoading', false);
      },
      error: function (error) {
        if (requests.nullMessage(error.responseJSON.message)) {
          GlobalEudoxusBus.$emit('alertDialogToggle', ({
            flag: true,
            msg: properties.getErrorMessage(error.responseJSON.message)
          }));
          GlobalEudoxusBus.$emit('bookListComponentRenderDto', null);
          GlobalEudoxusBus.$emit('toggleLoading', false);
        }
      }
    });
  },

  refreshBooksForDelivery(pin, receiverIdentification, callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "getBooksForDelivery",
      data: {
        pin: pin,
        receiverIdentification: receiverIdentification
      },
      cache: false,
      timeout: 600000,
      success: function (result) {
        let object = [];
        let credits = [];
        credits.push({pin: pin, receiverIdentification: receiverIdentification});
        object.push({result: result, credits: credits});
        callbackSuccess(object);
      },
      error: function (error) {
        if (requests.nullMessage(error.responseJSON.message)) {
          GlobalEudoxusBus.$emit('alertDialogToggle', ({
            flag: true,
            msg: properties.getErrorMessage(error.responseJSON.message)
          }));
          GlobalEudoxusBus.$emit('bookListComponentRenderDto', null);
        }
      }
    });
  },

  returnBook(statementBookId, pin, receiverIdentification, callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "returnBook",
      data: {
        statementBookId: statementBookId
      },
      cache: false,
      timeout: 600000,
      success: function (result) {
      },
      error: function (error) {
        if (error.statusText === "OK")
          requests.refreshBooksForDelivery(pin, receiverIdentification, callbackSuccess);
        else if (error.responseJSON.message != null) {
          GlobalEudoxusBus.$emit('alertDialogToggle', ({
            flag: true,
            msg: properties.getErrorMessage(error.responseJSON.message)
          }));
          callbackSuccess(null);
        } else
          requests.reloadEudoxusPage("return Book");
      }
    });
  },

  deliverBook(statementBookId, pin, receiverIdentification, callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "deliverBook",
      data: {
        statementBookId: statementBookId,
        receiverIdentification: receiverIdentification
      },
      cache: false,
      timeout: 600000,
      success: function () {
      },
      error: function (error) {
        if (error.statusText === "OK") {
          requests.refreshBooksForDelivery(pin, receiverIdentification, callbackSuccess);
        } else if (error.responseJSON.message != null) {
          GlobalEudoxusBus.$emit('alertDialogToggle', ({
            flag: true,
            msg: properties.getErrorMessage(error.responseJSON.message)
          }));
          callbackSuccess(null);
        } else
          requests.reloadEudoxusPage("deliver Book");
      }
    });
  },

  getAcademicYearsSelect(name, callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "getAcademicYearsSelect",
      dataType: "text",
      cache: false,
      timeout: 600000,
      success: function (result) {
        let object = JSON.parse(result);
        let options = [];
        for (let i = 0; i < object.length; i++)
          options.push({value: object[i].year, text: object[i].value});
        callbackSuccess(options);
      },
      error: function () {
        requests.reloadEudoxusPage("getAcademic Years Selected");
      }
    });
  },

  getSecretariats(callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "getSecretariats",
      cache: false,
      timeout: 600000,
      success: function (result) {
        callbackSuccess(result);
      },
      error: function (error) {
        console.log(JSON.stringify(error));
        requests.reloadEudoxusPage("getSecretariats");
      }
    });
  },

  getSelectedSecretariats(distributionPointId, year, callbackSuccess) {
    GlobalEudoxusBus.$emit('toggleLoading', true);
    $.ajax({
      type: "POST",
      url: BASE_URL + "getSelectedSecretariats",
      data: {
        distributionPointId: distributionPointId,
        year: year
      },
      cache: false,
      async: false,
      timeout: 600000,
      success: function (result) {
        GlobalEudoxusBus.$emit('toggleLoading', false);
        callbackSuccess(result);
      },
      error: function () {
        requests.reloadEudoxusPage("getSelectedSecretariats");
      }
    });
  },

  addSecretariatToDistributionPoint(distributionPointId, secretariatId, year, callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "addSecretariatToDistributionPoint",
      data: {
        distributionPointId: distributionPointId,
        secretariatId: secretariatId,
        year: year
      },
      cache: false,
      timeout: 600000,
      success: function (result) {
        callbackSuccess(result);
      },
      error: function (error) {
        if (error.statusText === "OK")
          callbackSuccess([]);
        else if (requests.nullMessage(error.responseJSON.message)) {
          GlobalEudoxusBus.$emit('alertDialogToggle', ({
            flag: true,
            msg: properties.getErrorMessage(error.responseJSON.message)
          }));
          callbackSuccess([]);
        }
      }
    });
  },

  removeSecretariatFromDistributionPoint(distributionPointId, secretariatId, year, callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "removeSecretariatFromDistributionPoint",
      data: {
        distributionPointId: distributionPointId,
        secretariatId: secretariatId,
        year: year
      },
      cache: false,
      timeout: 600000,
      success: function (result) {
        callbackSuccess(result);
      },
      error: function (error) {
        if (error.statusText === "OK")
          callbackSuccess([]);
        else if (requests.nullMessage(error.responseJSON.message)) {
          GlobalEudoxusBus.$emit('alertDialogToggle', ({flag: true, msg: properties.getErrorMessage(error.responseJSON.message)}));
          callbackSuccess([]);
        }
      }
    });
  },

  copyDistributionPointSecretariats(distributionPointId, fromYear, toYear, callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "copyDistributionPointSecretariats",
      data: {
        distributionPointId: distributionPointId,
        fromYear: fromYear,
        toYear: toYear
      },
      cache: false,
      timeout: 600000,
      success: function (result) {
        callbackSuccess(result);
      },
      error: function (error) {
        //ToDo CopyDistribution From Other Tab
        console.log(error);
        if (requests.nullMessage(error.responseJSON.message)) {
          GlobalEudoxusBus.$emit('alertDialogToggle', ({
            flag: true,
            msg: properties.getErrorMessage(error.responseJSON.message)
          }));
          callbackSuccess(null);
        }
      }
    });
  },

  getBooksAvailabilityForDistributionPoint(distributionPointId, year, callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "getBooksAvailabilityForDistributionPoint",
      data: {
        distributionPointId: distributionPointId,
        year: year
      },
      cache: false,
      timeout: 600000,
      success: function (result) {
        callbackSuccess(result);
      },
      error: function (error) {
        console.log(error);
        if (requests.nullMessage(error.responseJSON.message)) {
          GlobalEudoxusBus.$emit('alertDialogToggle', ({
            flag: true,
            msg: properties.getErrorMessage(error.responseJSON.message)
          }));
        }
      }
    });
  },

  updateBookAvailability(distributionPointId, bookId, year, totalIncrement, object, callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "updateBookAvailaibility",
      data: {
        distributionPointId: distributionPointId,
        bookId: bookId,
        year: year,
        totalIncrement: totalIncrement
      },
      cache: false,
      timeout: 600000,
      success: function (result) {
        callbackSuccess(object, result);
      },
      error: function (error) {
        console.log(error);
        if (requests.nullMessage(error.responseJSON.message)) {
          GlobalEudoxusBus.$emit('alertDialogToggle', ({
            flag: true,
            msg: properties.getErrorMessage(error.responseJSON.message)
          }));
          callbackSuccess(null, null);
        }
      }
    });
  },

  getBook(bookId, callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "getBook",
      data: {
        bookId: bookId
      },
      cache: false,
      timeout: 600000,
      success: function (result) {
        callbackSuccess(result);
      },
      error: function () {
        requests.reloadEudoxusPage("getBook");
      }
    });
  },

  getPublishers(callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "getPublishers",
      cache: false,
      timeout: 600000,
      success: function (result) {
        //console.log(result);
        callbackSuccess(result);
      },
      error: function () {
        requests.reloadEudoxusPage("getPublishers");
      }
    });
  },

  getBookAvailabilitiesForPublisher(publisherId, callbackSuccess) {
    $.ajax({
      type: "POST",
      url: BASE_URL + "getBookAvailabilitiesForPublisher",
      data: {
        publisherId: publisherId
      },
      cache: false,
      timeout: 600000,
      success: function (result) {
        callbackSuccess(result);
      },
      error: function () {
        requests.reloadEudoxusPage("getBookAvailabilitiesForPublisher");
      }
    });
  },

  getSubmitFileDownload(token, format, from, to, pin) {
    let url = BASE_URL + "fileManageService?token=" + token + "&format=" + format + "&from=" + from + "&to=" + to + "&pin=" + pin;
    window.open(url, '_blank');
  },

  getDistributionPointId() {
    return this.DISTRIBUTION_POINT_ID;
  },

  EudoxusGlobalVariables(result) {
    if (result != null && result.length !== 0) {
      this.DISTRIBUTION_POINT_ID = result.id;
      result.distributionPointType === 'DistributionPoint' ? this.DISTRIBUTION_POINT_TYPE = true : this.DISTRIBUTION_POINT_TYPE = false;
    }
  },

  // DistributionPoint == True      ----      Secretariat == false
  getDistributionType() {
    if (this.DISTRIBUTION_POINT_TYPE != null)
      return this.DISTRIBUTION_POINT_TYPE;
    else
      return true;
  },

  reloadEudoxusPage(name) {
    requests.logout();
  },

  nullMessage(msg) {
    if (msg == null) {
      requests.reloadEudoxusPage("null Message");
      return false;
    }
    return true;
  },

  getCookie(name) {
    let regexp = new RegExp("(?:^" + name + "|;\s*"+ name + ")=(.*?)(?:;|$)", "g");
    let result = regexp.exec(document.cookie);
    return (result === null) ? null : result[1];
  }
};

export default requests



// WEBPACK FOOTER //
// ./src/js/DistributionRequestService.js